WYATT.registerComponent(
  "product-form",
  class ProductForm extends HTMLElement {
    sectionsToRender = [
      {
        name: "cart-count",
        selector: "[data-cart-count]",
      },
      {
        name: "mini-cart",
        selector: "[data-mini-cart]",
      },
      {
        name: "mini-cart",
        selector: ".drawer__footer",
      },
    ];

    constructor() {
      super();

      this.form = this.querySelector("form");

      this.form.addEventListener("submit", this.handleSubmit.bind(this));
    }

    handleSubmit(event) {
      event.preventDefault();

      this.addLoading();
      this.addToCart();
    }

    getSectionNames() {
      return [...new Set(this.sectionsToRender.map((section) => section.name))];
    }

    getBody() {
      const formData = new FormData(this.form);
      const attributes = this.form.querySelectorAll('[name*="attributes"]');
      const properties = this.form.querySelectorAll('[name*="properties"]');

      const body = {
        items: [
          {
            id: formData.get("id"),
            quantity: formData.get("quantity"),
            properties: {},
          },
        ],
        sections: this.getSectionNames(),
        attributes: {},
      };

      attributes.forEach((input) => {
        const attributeName = input.name.replace(/(^.*\[|\].*$)/g, "");

        body.attributes[attributeName] = input.value;
      });

      properties.forEach((input) => {
        const propertyName = input.name.replace(/(^.*\[|\].*$)/g, "");

        body.items[0].properties[propertyName] = input.value;
      });

      return body;
    }

    async addToCart() {
      const body = this.getBody();
      const options = {
        ...WYATT.fetchConfig(),
        ...{ body: JSON.stringify(body) },
      };

      const response = await WYATT.asyncRequest(
        `${WYATT.routes.cart_add_url}.js`,
        options
      );

      if (response) {
        this.handleSuccessfulAdd(response);
      }

      this.removeLoading();
    }

    handleSuccessfulAdd(state) {
      const parsedState = JSON.parse(state);

      if (!parsedState.sections) {
        window.location.reload();
        return;
      }

      this.sectionsToRender.forEach((section) =>
        WYATT.replaceDOM(parsedState.sections[section.name], section.selector)
      );
      document
        .querySelector('[data-drawer-open="[data-mini-cart-drawer]"]')
        .click();
    }

    addLoading() {
      this.classList.add("product-form--is-loading");
    }

    removeLoading() {
      this.classList.remove("product-form--is-loading");
    }
  }
);
